import { render, staticRenderFns } from "./WenzhenOver.vue?vue&type=template&id=1dadecea&scoped=true"
import script from "./WenzhenOver.vue?vue&type=script&lang=js"
export * from "./WenzhenOver.vue?vue&type=script&lang=js"
import style0 from "./WenzhenOver.vue?vue&type=style&index=0&id=1dadecea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dadecea",
  null
  
)

export default component.exports